module.exports = __WEBPACK_EXTERNAL_MODULE_image_size__;